import { gql } from '@apollo/client'

export const CreateGuest = gql`
  mutation CreateGuest($roomId: ID) {
    createGuest(roomId: $roomId) {
      user {
        id
        created
        email
        invites {
          id
          issuer { id username }
          room { id name owner { id username } }
        }
        rooms {
          id
          name
          topic
          spinning
          admins { id username }
          members { id username }
        }
        roles
        updated
        username
      }
      refreshToken
      accessToken
    }
  }
`

export default CreateGuest
